import { Card, Box, styled } from "@mui/material";

// STYLED COMPONENTS
const CardRoot = styled(Card)({
  height: "100%",
  padding: "20px 24px",
  border: "1px solid #ccc"
});

const CardTitle = styled("div")(({ subtitle }) => ({
  fontSize: "2rem",
  fontWeight: "700",
  textTransform: "capitalize",
  marginBottom: !subtitle && "16px"
}));

export default function SimpleCard({ children, title, subtitle }) {
  return (
    <CardRoot elevation={6} sx={{ mt: 3 }}>
      <CardTitle subtitle={subtitle}>{title}</CardTitle>
      {subtitle && <Box mb={2}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
}
